import React, { useState, useEffect, useCallback } from "react";
import axios from "../utils/axiosInstance";

const fmt = (d) => d ? new Date(d).toLocaleDateString("rw-RW", { day:"2-digit", month:"short", year:"numeric" }) : "—";

export default function AbashyitsiAkagari() {
  const [visitors, setVisitors] = useState([]);
  const [total, setTotal]       = useState(0);
  const [loading, setLoading]   = useState(true);
  const [search, setSearch]     = useState("");
  const [page, setPage]         = useState(1);
  const [toast, setToast]       = useState(null);
  const LIMIT = 20;

  const notify = (msg, type = "err") => { setToast({ msg, type }); setTimeout(() => setToast(null), 4000); };

  const fetchVisitors = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/cell/visitors", { params: { page, limit: LIMIT, search: search || undefined } });
      setVisitors(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch { notify("Habaye ikosa mu gusoma amakuru."); }
    finally { setLoading(false); }
  }, [page, search]);

  useEffect(() => { fetchVisitors(); }, [fetchVisitors]);

  const totalPages = Math.ceil(total / LIMIT);
  const cols = ["#","Amazina","Indangamuntu","Telefone","Aho Atuye","Isibo Yamwakiriye","Mudugudu Wamwohereje","Yoherejwe","Status"];

  return (
    <div style={{ fontFamily:"Nunito Sans, sans-serif", color:"#1e293b" }}>
      <div style={{ marginBottom:20 }}>
        <h2 style={{ margin:0, fontSize:"1.25rem", fontWeight:800, color:"#1e293b", display:"flex", alignItems:"center", gap:8 }}>
          <i className="bi bi-person-lines-fill" style={{ color:"#7c3aed" }} /> Reba Abashyitsi Dufite
        </h2>
        <p style={{ margin:"4px 0 0", fontSize:"0.78rem", color:"#64748b" }}>Abashyitsi boherejwe na Mudugudu</p>
      </div>

      {/* Stats bar */}
      <div style={{ display:"flex", alignItems:"center", gap:12, padding:"12px 16px", background:"#f8fafc", borderRadius:10, border:"1px solid #e2e8f0", marginBottom:16 }}>
        <span style={{ fontSize:"0.82rem", color:"#475569", fontWeight:600 }}>Igiteranyo:</span>
        <span style={{ fontSize:"1.1rem", fontWeight:800, color:"#7c3aed" }}>{total}</span>
        <span style={{ fontSize:"0.82rem", color:"#64748b" }}>abashyitsi boherejwe</span>
      </div>

      {/* Toolbar */}
      <div style={{ display:"flex", gap:10, marginBottom:16, flexWrap:"wrap" }}>
        <div style={{ display:"flex", alignItems:"center", gap:8, flex:"1 1 220px", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, padding:"0 12px", minWidth:0 }}>
          <i className="bi bi-search" style={{ color:"#94a3b8" }} />
          <input value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} placeholder="Shakisha amazina, telefone..."
            style={{ border:"none", background:"transparent", outline:"none", padding:"0.6rem 0.25rem", fontSize:"0.88rem", color:"#1e293b", width:"100%" }} />
          {search && <button onClick={() => { setSearch(""); setPage(1); }} style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", padding:0 }}><i className="bi bi-x-circle-fill" /></button>}
        </div>
        <button onClick={fetchVisitors} disabled={loading} style={{ display:"flex", alignItems:"center", gap:6, padding:"0.55rem 1rem", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, cursor:"pointer", fontSize:"0.85rem", color:"#475569", fontWeight:600 }}>
          <i className="bi bi-arrow-clockwise" /> Vugurura
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign:"center", padding:"4rem 0" }}>
          <div className="spinner-border text-primary" style={{ width:"3rem", height:"3rem" }} />
          <p style={{ marginTop:"1rem", color:"#64748b" }}>Gutegereza...</p>
        </div>
      ) : visitors.length === 0 ? (
        <div style={{ textAlign:"center", padding:"5rem 2rem", background:"#f8fafc", borderRadius:14, border:"1px solid #e2e8f0" }}>
          <i className="bi bi-person-x" style={{ fontSize:"2.5rem", color:"#94a3b8", display:"block", marginBottom:12 }} />
          <h5 style={{ color:"#1e293b", fontWeight:700 }}>{search ? "Nta mushyitsi wabonetse" : "Nta mushyitsi woherejwe kuri ubu"}</h5>
        </div>
      ) : (
        <>
          <div style={{ overflowX:"auto", borderRadius:12, border:"1px solid #e2e8f0", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"0.82rem" }}>
              <thead>
                <tr style={{ background:"#f1f5f9" }}>
                  {cols.map(h => (
                    <th key={h} style={{ padding:"10px 14px", textAlign:"left", fontSize:"0.68rem", fontWeight:700, color:"#475569", textTransform:"uppercase", letterSpacing:"0.05em", whiteSpace:"nowrap", borderBottom:"1px solid #e2e8f0" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {visitors.map((v, i) => (
                  <tr key={v.id} style={{ borderBottom:"1px solid #f1f5f9", background: i%2===0 ? "#fff" : "#f8fafc" }}>
                    <td style={{ padding:"10px 14px", color:"#94a3b8" }}>{(page-1)*LIMIT + i + 1}</td>
                    <td style={{ padding:"10px 14px", fontWeight:600, color:"#1e293b" }}>{v.visitor_name}</td>
                    <td style={{ padding:"10px 14px", color:"#64748b" }}>{v.visited_person_id || "—"}</td>
                    <td style={{ padding:"10px 14px", color:"#64748b" }}>{v.visitor_phone || "—"}</td>
                    <td style={{ padding:"10px 14px", color:"#64748b" }}>
                      {[v.visitor_village, v.visitor_cell, v.visitor_sector, v.visitor_district].filter(Boolean).join(", ") || "—"}
                    </td>
                    <td style={{ padding:"10px 14px", color:"#1d4ed8", fontWeight:600 }}>{v.isibo_name || "—"}</td>
                    <td style={{ padding:"10px 14px", color:"#0f766e", fontWeight:600 }}>{v.mudugudu_name || "—"}</td>
                    <td style={{ padding:"10px 14px", color:"#64748b", whiteSpace:"nowrap" }}>{fmt(v.sent_to_cell_at)}</td>
                    <td style={{ padding:"10px 14px" }}>
                      <span style={{ padding:"3px 10px", borderRadius:20, fontSize:"0.72rem", fontWeight:700, background:"#dcfce7", color:"#15803d", border:"1px solid #bbf7d0" }}>
                        ✅ Yakiriwe
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:8, marginTop:16 }}>
              <button onClick={() => setPage(p => Math.max(1, p-1))} disabled={page===1}
                style={{ padding:"6px 14px", borderRadius:8, border:"1px solid #e2e8f0", background: page===1 ? "#f8fafc" : "#fff", color: page===1 ? "#94a3b8" : "#475569", fontWeight:600, cursor: page===1 ? "default" : "pointer", fontSize:"0.82rem" }}>
                ← Imbere
              </button>
              {Array.from({ length: Math.min(5, totalPages) }, (_, idx) => {
                const p = Math.max(1, Math.min(totalPages-4, page-2)) + idx;
                return (
                  <button key={p} onClick={() => setPage(p)}
                    style={{ width:32, height:32, borderRadius:8, border:`1px solid ${page===p ? "#7c3aed" : "#e2e8f0"}`, background: page===p ? "#7c3aed" : "#fff", color: page===p ? "#fff" : "#475569", fontWeight:700, cursor:"pointer", fontSize:"0.82rem" }}>
                    {p}
                  </button>
                );
              })}
              <button onClick={() => setPage(p => Math.min(totalPages, p+1))} disabled={page===totalPages}
                style={{ padding:"6px 14px", borderRadius:8, border:"1px solid #e2e8f0", background: page===totalPages ? "#f8fafc" : "#fff", color: page===totalPages ? "#94a3b8" : "#475569", fontWeight:600, cursor: page===totalPages ? "default" : "pointer", fontSize:"0.82rem" }}>
                Inyuma →
              </button>
            </div>
          )}
        </>
      )}

      {toast && (
        <div style={{ position:"fixed", top:20, right:20, zIndex:9999, padding:"12px 20px", borderRadius:12, fontWeight:600, fontSize:14, background:"#fef2f2", color:"#991b1b", border:"1px solid #fecaca", boxShadow:"0 4px 20px rgba(0,0,0,0.1)" }}>
          {toast.msg}
        </div>
      )}
    </div>
  );
}
